import {TeamSeason} from '../resources/TeamSeason';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@see TeamSeasonsExportRequested} event is available and can be processed.
 */
export class TeamSeasonsExportAvailable extends EntityExportAvailableEvent<TeamSeason> {
}
